import React from "react"

const SVG_PROPS = {
  width: 16,
  height: 16,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
}

function SvgIcon({ className, children, ...rest }) {
  return (
    <svg className={className} {...SVG_PROPS} {...rest}>
      {children}
    </svg>
  )
}

/** Checklist — Feature Access */
export function PlanFeatureAccessIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M3 12h13" />
      <path d="M3 18h7" />
      <path d="M3 6h13" />
      <path d="m15 6 2 2 4-4" />
      <path d="m15 12 2 2 4-4" />
    </SvgIcon>
  )
}

/** Armchair + sparkle — Furniture Tools */
export function PlanFurnitureToolsIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M19 9V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3" />
      <path d="M3 11v5a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v-1.5a2 2 0 0 0-4 0V11a2 2 0 0 0-4 0v1.5a2 2 0 0 0-4 0z" />
      <path d="m17.5 3.5-.9 1.8-1.8.9 1.8.9.9 1.8.9-1.8 1.8-.9-1.8-.9-.9-1.8z" />
    </SvgIcon>
  )
}

/** Pen tool + sparkle — AI Design Tools */
export function PlanAiImageToolsIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l8.586-8.586a2 2 0 0 1 2.828 0l1.586 1.586a1 1 0 0 1 0 1.414z" />
      <path d="m18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18" />
      <path d="m20 4.5-.9 1.8-1.8.9 1.8.9.9 1.8.9-1.8 1.8-.9-1.8-.9-.9-1.8z" />
    </SvgIcon>
  )
}

/** Floor plan layout — Room Planner */
export function PlanRoomPlannerIcon(props) {
  return (
    <SvgIcon {...props}>
      <rect width="18" height="7" x="3" y="3" rx="1" />
      <rect width="9" height="7" x="3" y="14" rx="1" />
      <rect width="5" height="7" x="16" y="14" rx="1" />
    </SvgIcon>
  )
}

/** Expanding room / maximize — Advanced Spaces */
export function PlanAdvancedSpacesIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M3 7V4a1 1 0 0 1 1-1h3" />
      <path d="M17 3h3a1 1 0 0 1 1 1v3" />
      <path d="M21 17v3a1 1 0 0 1-1 1h-3" />
      <path d="M7 21H4a1 1 0 0 1-1-1v-3" />
      <rect width="8" height="8" x="8" y="8" rx="1" />
    </SvgIcon>
  )
}

/** Lightbulb — Upcoming Features */
export function PlanUpcomingFeaturesIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
      <path d="M9 18h6" />
      <path d="M10 22h4" />
    </SvgIcon>
  )
}

export const PLAN_METADATA_CATEGORY_ICONS = {
  feature_access: PlanFeatureAccessIcon,
  furniture_tools: PlanFurnitureToolsIcon,
  ai_image_tools: PlanAiImageToolsIcon,
  room_planner: PlanRoomPlannerIcon,
  advanced_spaces: PlanAdvancedSpacesIcon,
  upcoming_features: PlanUpcomingFeaturesIcon,
}

export function getPlanMetadataCategoryIcon(slug) {
  return PLAN_METADATA_CATEGORY_ICONS[slug] || PlanFeatureAccessIcon
}
